import { createContext } from "react";
import { useJsApiLoader } from "@react-google-maps/api";

export const GoogleMapsContext = createContext(null);
const GOOGLE_MAPS_LIBRARIES = ["places", "maps"]; // ✅ stable et jamais recréé

export const GoogleMapsProvider = ({ children }) => {
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyCTQZ0lM4lvIDdfBd9dqRxpiQgJohmyh0E",
    libraries: GOOGLE_MAPS_LIBRARIES,
    id: "script-loader",
  });

  return (
    <GoogleMapsContext.Provider value={{ isLoaded, loadError }}>
      {children}
    </GoogleMapsContext.Provider>
  );
};
